/**
 * Runtime Environment Variables
 *
 * For S3 deployments - values computed at runtime based on domain.
 * Based on: recruiter-ui/app/runtimeEnvVars.js
 */

import { domainMeta } from '@/utils/domain-meta';

export const WX_NAVBAR_VERSION = 'v3';

export const WX_NAVBAR_RELEASE_CHANNEL: string =
  import.meta.env.VITE_WX_NAVBAR_RELEASE_CHANNEL ??
  (domainMeta.environment === 'prod' ? 'stable' : 'main');

export const WX_COPILOT_VERSION = 'v3';

export const WX_COPILOT_RELEASE_CHANNEL: string =
  import.meta.env.VITE_WX_COPILOT_RELEASE_CHANNEL ??
  (domainMeta.environment === 'prod' ? 'stable' : 'main');

export const WX_LAUNCH_DARKLY_CLIENT_SIDE_ID: string =
  import.meta.env.VITE_WX_LAUNCH_DARKLY_CLIENT_SIDE_ID ??
  domainMeta.launchDarklyClientSideId;

export const I18N_LOG_MISSING_TRANSLATIONS =
  import.meta.env.VITE_I18N_LOG_MISSING_TRANSLATIONS ?? 'false';

export const POSTHOG_HOST: string =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? '';
export const POSTHOG_API_KEY: string =
  (import.meta.env.VITE_POSTHOG_API_KEY as string | undefined) ?? '';
export const POSTHOG_DEBUG: string =
  (import.meta.env.VITE_POSTHOG_DEBUG as string | undefined) ?? '';
